<div class="wrapper" *ngIf="(this.authentication.userData.User.MobileNumber != null && this.authentication.userData.User.EmailAddress != null)">
    <nav id="sidebar">

        <!--<div class="sidebar-header">-->

        <!-- <ul class="list-unstyled components" style="margin:0px;padding:0px;">
        <li>
          <a *ngIf="authentication.authenticated" href="#userSubMenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle spacer-x"
             role="button" aria-haspopup="true" >
             {{authentication.userData?.User?.FirstName}} {{authentication.userData?.User?.LastName}} <span class="caret"></span>
          </a>
          <ul *ngIf="authentication.authenticated" class="collapse list-unstyled" id="userSubMenu">
            <li>
              <a class="inner menu-shd"  [routerLink]="['/ammenduser']">
                Profile
              </a>
            </li>
            <li>
              <a class="inner menu-shd" [routerLink]="['/reset']">
                Reset Password
              </a>
            </li>
            <li>
              <a class="inner menu-shd" (click)="authentication.logout()" style="cursor: pointer;">
                Logout
              </a>
            </li>
          </ul>
        </li>
      </ul> -->

        <!--</div>-->
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
        <ul class="list-unstyled components" style="margin:0px;padding:0px;">
            <li *ngIf="authentication.authenticated"><a [routerLink]="['/home']" class="spacer-x menu-mhd">Home</a></li>
            <li *ngFor="let mm of authentication.userData?.MainMenus" [style.display]="authentication.authenticated && subMenus(mm).length ? 'block' : 'none'">
                <a href="#{{mm.Code}}" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle spacer-x">{{mm.Name}}<span class="caret"></span></a>
                <ul class="collapse list-unstyled" id="{{mm.Code}}">
                    <li *ngIf="mm.Code=='ADMIN'">
                        <a class="inner" href="javascript:void(0);" (click)="navAuthWeb()"><i class="fa fa-play" aria-hidden="true">&nbsp;<span class="menu-shd">Auth-Web</span></i></a>
                    </li>
                    <li *ngIf="mm.Code=='BO'">
                        <a class="inner" href="javascript:void(0);" (click)="navWFDashboard()"><i class="fa fa-play" aria-hidden="true">&nbsp;<span class="menu-shd">Workflow Permits</span></i></a>
                    </li>
                    <li *ngIf="mm.Code=='BO'">
                        <a class="inner" href="javascript:void(0);" (click)="navSharePoint()"><i class="fa fa-play"  aria-hidden="true">&nbsp;<span class="menu-shd">Workflow Carriers</span></i></a>
                    </li>
                    <li *ngIf="mm.Code=='RE'">
                        <a class="inner" href="javascript:void(0);" (click)="subReport()"><i class="fa fa-play"  aria-hidden="true">&nbsp;<span class="menu-shd">Reports</span></i></a>
                    </li>
                    <li *ngFor="let sm of subMenus(mm)">
                        <a class="inner menu-shd" [routerLink]="[pathFromScreenName(sm.ScreenName)]" [queryParams]="queryParamsFromScreenName(sm.ScreenName)" (click)="menuClicked(sm)"><i class="fa fa-play" aria-hidden="true">&nbsp;<span class=" menu-shd">{{sm.Name}}</span></i></a>
                    </li>
                </ul>
            </li>

        </ul>
        <ul class="list-unstyled components" style="margin:0px;padding:0px;">
            <!-- <li  *ngIf="authentication.authenticated">
    <a  class="spacer-x menu-mhd"
       [routerLink]="['/carrier/externalvehicles']"><i class="fa fa-user-plus" aria-hidden="true"></i>&nbsp;External Vehicles</a>
  </li> -->
            <li *ngIf="!authentication.authenticated">
                <a class="spacer-c menu-mhd" [routerLink]="['/login']">
                    <i class="fa fa-sign-in"></i>&nbsp;Login
                </a>
            </li>
            <li *ngIf="!authentication.authenticated">
                <a class="spacer-x menu-mhd" [routerLink]="['/register']"><i class="fa fa-user-plus" aria-hidden="true"></i>&nbsp;Create User Profile</a>
            </li>
        </ul>
    </nav>

</div>
